
import './Subtitle.css';
function Subtitle({text}) {
  return (
    <>
      <p className='subtitle-element'>{text}</p>
    </>
  );
}

export default Subtitle;
